import React from "react";
import styles from "./SpinnerStyles.module.scss";
export const PauseSpinner: React.FC = () => {
    return <div className={`${styles.pauseSpinner} border-light`}></div>;
};
